// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isAppsAppGroupIdChartsSmsResult = objectOf({
  daily_sms_stats: objectOf({
    sent_count_by_hour: arrayOf(arrayOf(number)),
    sent_to_carrier_count_by_hour: arrayOf(arrayOf(number)),
    delivered_count_by_hour: arrayOf(arrayOf(number)),
    delivery_failed_count_by_hour: arrayOf(arrayOf(number)),
    rejected_count_by_hour: arrayOf(arrayOf(number)),
    opt_in_count_by_hour: arrayOf(arrayOf(number)),
    opt_out_count_by_hour: arrayOf(arrayOf(number)),
    help_count_by_hour: arrayOf(arrayOf(number)),
    click_count_by_hour: arrayOf(arrayOf(number)),
  }),
});
